import React, { useState } from 'react';

const ZoomImage = ({ src, alt }) => {
  // State to track mouse position
  const [zoom, setZoom] = useState({
    scale: 1,
    position: { x: 0, y: 0 },
  });

  // Mouse enter event handler to trigger zoom
  const handleMouseEnter = () => {
    setZoom((prevZoom) => ({ ...prevZoom, scale: 3.5 }));
  };

  // Mouse leave event handler to reset zoom
  const handleMouseLeave = () => {
    setZoom((prevZoom) => ({ ...prevZoom, scale: 1 }));
  };

  // Mouse move event handler to update position
  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setZoom((prevZoom) => ({
      ...prevZoom,
      position: { x, y },
    }));
  };

  return (
    <div
      className="relative w-80 h-96 overflow-hidden"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-contain hover:cursor-zoom-in transition-transform duration-300"
        style={{
          transform: `scale(${zoom.scale})`,
          transformOrigin: `${zoom.position.x}% ${zoom.position.y}%`,
        }}
      />
    </div>
  );
};

export default ZoomImage;
